module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "page-contain"
  }, [_c('div', {
    staticClass: "page-contain-tab"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('div', {
    staticClass: "search-content"
  }, [_c('div', {
    staticClass: "search-content-fields"
  }, [_c('el-form', {
    attrs: {
      "label-position": "top"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "部门"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.searchData.medicalField = '';
        _vm.searchData.teamL4 = ''
      }
    },
    model: {
      value: (_vm.searchData.departId),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "departId", $$v)
      },
      expression: "searchData.departId"
    }
  }, _vm._l(((_vm.isConfigurationData ? _vm.departsList : _vm.userInfo.loginDeparts)), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.departName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Franchise/DA"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.searchData.teamL4 = ''
      }
    },
    model: {
      value: (_vm.searchData.medicalField),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "medicalField", $$v)
      },
      expression: "searchData.medicalField"
    }
  }, _vm._l(((_vm.isConfigurationData ? _vm.medicalFieldList : _vm.getMedicalFieldArray(_vm.searchData.departId, true))), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.medicalFieldName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "团队"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.teamL4),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "teamL4", $$v)
      },
      expression: "searchData.teamL4"
    }
  }, _vm._l(((_vm.isConfigurationData ? _vm.teamList : _vm.getTeamArray(_vm.searchData.departId, _vm.searchData.medicalField, true))), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.teamName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "产品"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择（可搜索）"
    },
    model: {
      value: (_vm.searchData.prodIds),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "prodIds", $$v)
      },
      expression: "searchData.prodIds"
    }
  }, _vm._l((_vm.baseDataRecords.Product), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.productName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "自定义/标准"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.typeId),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "typeId", $$v)
      },
      expression: "searchData.typeId"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "标准",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "自定义",
      "value": "1"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "医院层级"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择（可搜索）"
    },
    model: {
      value: (_vm.searchData.hospitalLevel),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "hospitalLevel", $$v)
      },
      expression: "searchData.hospitalLevel"
    }
  }, _vm._l((_vm.hospitalLevelNames), function(item) {
    return _c('el-option', {
      key: item.hospitalLevel,
      attrs: {
        "value": item.hospitalLevel,
        "label": item.hospitalLevel
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    staticClass: "btn-search",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSearch()
      }
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "operate"
  }, [_c('div', [_c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.handlerExportExcelClick()
      }
    }
  }, [_vm._v("批量导出")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": !_vm.canBatchDelete,
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.handleBatchDeleteClick()
      }
    }
  }, [_vm._v("批量删除")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleAddNewClick()
      }
    }
  }, [_vm._v("添加医院层级")])], 1)]), _vm._v(" "), _c('common-crud', {
    ref: "crud",
    attrs: {
      "addNewOrEditData": _vm.addNewOrEditData,
      "searchData": _vm.searchData,
      "searchDataLikeField": {
        'prodIds': ','
      },
      "crudApi": _vm.crudApi,
      "tableData": _vm.hospitallevelData,
      "showEditFormTitle": false,
      "beforeSave": _vm.beforeSave,
      "afterSave": _vm.handleHospitalLevelChange,
      "afterDelete": _vm.handleHospitalLevelChange,
      "selectedDataArray": _vm.selectedData,
      "otherValid": _vm.validUpload,
      "addSuccessMessages": "添加医院层级成功",
      "editSuccessMessages": "编辑医院层级成功",
      "deleteSuccessMessages": "删除医院层级成功",
      "deleteBatchSuccessMessages": "批量删除医院层级成功"
    },
    on: {
      "update:tableData": function($event) {
        _vm.hospitallevelData = $event
      },
      "update:table-data": function($event) {
        _vm.hospitallevelData = $event
      },
      "update:selectedDataArray": function($event) {
        _vm.selectedData = $event
      },
      "update:selected-data-array": function($event) {
        _vm.selectedData = $event
      }
    }
  }, [_c('template', {
    slot: "result"
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "index",
      "index": _vm.indexMethod,
      "width": "60",
      "label": "序号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.formatBaseData,
      "sortable": "",
      "prop": "departId",
      "label": "部门"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.formatBaseData,
      "sortable": "",
      "prop": "medicalField",
      "width": "135"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function(scope) {
        return [_c('div', {
          staticStyle: {
            "display": "inline-block"
          }
        }, [_c('div', [_vm._v("Franchise/DA")])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "teamL4",
      "label": "团队"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.formatBaseData,
      "sortable": "",
      "prop": "prodIds",
      "label": "产品"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.formatBaseData,
      "sortable": "",
      "prop": "typeId",
      "label": "标准/自定义",
      "width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "hospitalLevel",
      "label": "医院层级",
      "width": "110"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "modelScore",
      "label": "评分"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.formatDateTime2Date,
      "sortable": "",
      "prop": "updateTime",
      "label": "更新时间",
      "width": "110"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "updateBy",
      "label": "操作人"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "right",
      "label": "操作",
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "table-column-operate"
        }, [_c('el-button', {
          attrs: {
            "disabled": scope.row.typeId == '0',
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleEditClick(scope.row)
            }
          }
        }, [_vm._v("\n                    编辑\n                  ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "disabled": scope.row.typeId == '0',
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleDeleteClick(scope.row)
            }
          }
        }, [_vm._v("\n                    删除\n                  ")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('template', {
    slot: "customTitle"
  }, [_vm._v("医院层级")]), _vm._v(" "), _c('template', {
    slot: "editForm"
  }, [_c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "部门",
      "prop": "departId"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.addNewOrEditData.medicalField = '';
        _vm.addNewOrEditData.teamL4 = ''
      }
    },
    model: {
      value: (_vm.addNewOrEditData.departId),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "departId", $$v)
      },
      expression: "addNewOrEditData.departId"
    }
  }, _vm._l(((_vm.isConfigurationData ? _vm.departsList : _vm.userInfo.loginDeparts)), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.departName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "Franchise/DA",
      "prop": "medicalField"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.addNewOrEditData.teamL4 = ''
      }
    },
    model: {
      value: (_vm.addNewOrEditData.medicalField),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "medicalField", $$v)
      },
      expression: "addNewOrEditData.medicalField"
    }
  }, _vm._l(((_vm.isConfigurationData ? _vm.medicalFieldList : _vm.getMedicalFieldArray(_vm.addNewOrEditData.departId, false))), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.medicalFieldName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "团队",
      "prop": "teamL4"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addNewOrEditData.teamL4),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "teamL4", $$v)
      },
      expression: "addNewOrEditData.teamL4"
    }
  }, _vm._l(((_vm.isConfigurationData ? _vm.teamList : _vm.getTeamArray(_vm.addNewOrEditData.departId, _vm.addNewOrEditData.medicalField, false))), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.teamName
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "产品",
      "prop": "prodIds"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "multiple": "",
      "clearable": "",
      "placeholder": "请选择（可多选，可搜索）"
    },
    model: {
      value: (_vm.addNewOrEditData.prodIds),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "prodIds", $$v)
      },
      expression: "addNewOrEditData.prodIds"
    }
  }, _vm._l((_vm.baseDataRecords.Product), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.productName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "医院层级",
      "prop": "hospitalLevel"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.addNewOrEditData.hospitalLevel),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "hospitalLevel", $$v)
      },
      expression: "addNewOrEditData.hospitalLevel"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "评分（10分制）",
      "prop": "modelScore"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addNewOrEditData.modelScore),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "modelScore", $$v)
      },
      expression: "addNewOrEditData.modelScore"
    }
  }, _vm._l((10), function(n) {
    return _c('el-option', {
      key: n,
      attrs: {
        "label": n,
        "value": n
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('common-score', {
    ref: "strategyHospital4Hospital",
    attrs: {
      "disabledDownload": !_vm.canDownload,
      "title": "策略重点与医院层级",
      "type": "strategyHospital4Hospital",
      "fileName": "策略重点与医院层级.xlsx",
      "getExportParams": _vm.getScoreExportParams,
      "tipCode": "16"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('template', {
    slot: "confirmAddNewMessage"
  }, [_c('div', [_c('span', [_vm._v("确认添加医院层级？")])])]), _vm._v(" "), _c('template', {
    slot: "confirmEditMessage"
  }, [_c('div', [_c('span', [_vm._v("确认保存医院层级？")])])]), _vm._v(" "), _c('template', {
    slot: "confirmDeleteMessage"
  }, [_c('div', [_c('span', [_vm._v("删除医院层级？")])])]), _vm._v(" "), _c('template', {
    slot: "confirmBatchDeleteMessage"
  }, [_c('div', [_c('span', [_vm._v("批量删除医院层级？")])])])], 2)], 1)])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-421f5da2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-421f5da2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/bizmanagement/hospitallevel/index.vue
// module id = 1568
// module chunks = 7